module.exports = __webpack_public_path__ + "img/snowy_forest.aace80dc.jpg";